import * as React from 'react';
import { connect } from 'react-redux';

import Spinner from 'components/spinner/Spinner';

import './select-story-snippets-spinner.scss';

import { State } from 'types';

interface Props {
  isLoading: boolean
}

const SelectStorySnippetsSpinner = ({ isLoading }: Props): null | JSX.Element => {
  if (!isLoading) {
    return null;
  }

  return (
    <div className="select-story-snippets-spinner">
      <Spinner
        position="inline"
        size="small"
        color="light"
      />
    </div>
  );
};

const mapStateToProps = ({ selectStorySnippets }: State): Props => ({
  isLoading: selectStorySnippets.storySnippets === null
});

export default connect(mapStateToProps)(SelectStorySnippetsSpinner);
